// PRICING TIER OVERRIDES (shared between ServiceStep and CheckoutStep)
// Large luxury saloons (LWB/Limo class) are charged at ESTATE rate
// but displayed to customer as "Saloon" - pricing runs in background
export const PRICING_TIER_OVERRIDE = {
  // BMW - Large luxury saloons charged as estate
  "7 Series": "estate",
  "8 Series": "estate", 
  "i7": "estate",
  // Mercedes - Flagship saloons charged as estate
  "S-Class": "estate",
  "EQS": "estate",
  "CLS": "estate",
  // Audi - Large luxury saloons charged as estate
  "A7": "estate",
  "A8": "estate",
  "e-tron GT": "estate",
  // Lexus - Flagship charged as estate
  "LS": "estate",
  // Other large saloons
  "Model S": "estate",
  "Camry": "estate",
  "S90": "estate",
};

// Tesla Model 3 full rear glass premium
export const TESLA_FULL_REAR_PREMIUM = 40;

// Service type identifiers for exclusivity logic
export const FULL_CAR_TINT_IDS = ['svc_perf_full', 'svc_ceramic_full'];
export const PARTIAL_TINT_IDS = ['svc_perf_rear', 'svc_ceramic_rear',
                                 'svc_perf_front_doors', 'svc_ceramic_front_doors'];
export const PERFORMANCE_TINT_IDS = ['svc_perf_full', 'svc_perf_rear', 'svc_perf_front_doors', 'svc_perf_windshield'];
export const CERAMIC_TINT_IDS = ['svc_ceramic_full', 'svc_ceramic_rear', 'svc_ceramic_front_doors', 'svc_ceramic_windshield'];

// Slot hold duration
export const SLOT_HOLD_MINUTES = 5;
